<script setup>
import { computed } from "vue";
const props = defineProps(["selectedPrinter"]);
const alt = computed(() => {
    return props.selectedPrinter?.model_number
        ? `${props.selectedPrinter.model_number} product image`
        : "";
});
</script>

<template>
    <div class="product-compare-thumb">
        <img
            :src="
                props.selectedPrinter?.thumbnail ||
                '/assets/img/printer-slider-1-thumb.webp'
            "
            class="product-compare-thumb-img"
            :class="{ disabled: !props.selectedPrinter?.thumbnail }"
            :alt="alt"
        />
    </div>
</template>
